/*
 *
 * WishListPage reducer
 *
 */

import produce from 'immer';
import { ActionTypes } from './actions';

export const key = 'wishListPage';
export const initialState = {
    page: {
        res: [],
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
    },
    isAuthLoading: false,
    userImages: {
        res: [],
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
    },
};

/* eslint-disable no-param-reassign, default-case */
function wishListPageReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            // Page
            case ActionTypes.RESET_PAGE:
                draft.page.res = initialState.page.res;
                return draft;
            case ActionTypes.FETCH_PAGE_STARTED:
                draft.page.isLoading = true;
                draft.page.isError = false;
                draft.page.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_PAGE_SUCCESSFULLY:
                draft.page.isLoading = false;
                draft.page.isLoaded = true;
                draft.page.res = action.res;
                return draft;
            case ActionTypes.FETCH_PAGE_FAILED:
                draft.page.isLoading = false;
                draft.page.isError = true;
                draft.page.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_PAGE_CANCELLED:
                draft.page.isLoading = false;
                return draft;
            case ActionTypes.SET_PAGE_IS_LOADED:
                draft.page.isLoaded = action.isLoaded;
                return draft;
            case ActionTypes.SET_AUTH_STATUS:
                draft.isAuthLoading = action.isLoading;
                return draft;
            // userImages
            case ActionTypes.FETCH_USER_IMAGES_STARTED:
                draft.userImages.isLoading = true;
                draft.userImages.isError = false;
                draft.userImages.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_USER_IMAGES_SUCCESSFULLY:
                draft.userImages.isLoading = false;
                draft.userImages.isLoaded = true;
                draft.userImages.res = { ...action.res, ...draft.userImages.res };
                return draft;
            case ActionTypes.FETCH_USER_IMAGES_FAILED:
                draft.userImages.isLoading = false;
                draft.userImages.isError = true;
                draft.userImages.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_USER_IMAGES_CANCELLED:
                draft.userImages.isLoading = false;
                return draft;
            case ActionTypes.SET_USER_IMAGES_IS_LOADED:
                draft.userImages.isLoaded = action.isLoaded;
                return draft;
            default:
                return draft;
        }
    });
}

export default wishListPageReducer;
